import shopQueries from '@apis/queries/shopQueries';
import { useQuery } from '@tanstack/react-query';

function useShop(shopId: string) {
    const { data } = useQuery({
        ...shopQueries.detail(shopId),
        enabled: !!shopId,
    });

    return data;
}

export default useShop;
